export default __webpack_public_path__ + "static/media/art1.17afb3ba.jpg";